import { Button } from "@/components/ui/button";
import { ChevronDown, ChevronUp, Save, Trash2 } from "lucide-react";
import { toast } from "sonner";
import type { Section } from "../types";
interface SectionHeaderProps {
  section: Section;
  isExpanded: boolean;
  onToggle: () => void;
  onDelete: () => void;
  onSaveTemplate?: () => void;
  isSuperAdmin?: boolean;
}
export const SectionHeader = ({
  section,
  isExpanded,
  onToggle,
  onDelete,
  onSaveTemplate,
  isSuperAdmin = false
}: SectionHeaderProps) => {
  return <div className="p-4 flex items-center justify-between border-b px-[10px] py-0">
      <h3 className="text-base font-medium">
        {section.name || "Unnamed Section"}
      </h3>
      <div className="flex items-center gap-2">
        {isSuperAdmin && onSaveTemplate && <Button variant="ghost" size="icon" onClick={() => {
        onSaveTemplate();
        toast.success("Template saved successfully!");
      }}>
            <Save className="h-4 w-4 text-muted-foreground" />
          </Button>}
        <Button variant="ghost" size="icon" onClick={onDelete}>
          <Trash2 className="h-4 w-4 text-muted-foreground" />
        </Button>
        <Button variant="ghost" size="icon" onClick={onToggle}>
          {isExpanded ? <ChevronUp className="h-4 w-4 text-muted-foreground" /> : <ChevronDown className="h-4 w-4 text-muted-foreground" />}
        </Button>
      </div>
    </div>;
};